import styled from 'styled-components'

export const FilterBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
`

export const SearchField = styled.input`
  appearance: none;
  border: 0.0625rem solid ${({ theme }) => theme.grey400Color};
  border-radius: 0.5rem;
  padding: 0 1rem;
  height: 3rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.grey900Color};
  background: ${({ theme }) => theme.whiteColor};

  &::placeholder {
    color: ${({ theme }) => theme.grey700Color};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
  }
`

export const FilterDropdown = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 0.0625rem solid ${({ theme }) => theme.grey400Color};
  border-radius: 0.5rem;
  padding: 0 1rem;
  height: 3rem;
  cursor: pointer;
  background: ${({ theme }) => theme.whiteColor};

  &:hover {
    border-color: ${({ theme }) => theme.grey600Color};
  }

  &::after {
    content: '';
    position: absolute;
    right: 1rem;
    top: 50%;
    width: 0.5rem;
    height: 0.5rem;
    border-right: 0.125rem solid ${({ theme }) => theme.grey700Color};
    border-bottom: 0.125rem solid ${({ theme }) => theme.grey700Color};
    transform: translateY(-75%) rotate(45deg);
  }

  ul[role='menu'] {
    position: absolute;
    top: calc(100% + 0.25rem);
    left: 0;
    right: 0;
    z-index: 10;
    margin: 0;
    padding: 0.25rem 0;
    list-style: none;
    background: ${({ theme }) => theme.whiteColor};
    border: 0.0625rem solid ${({ theme }) => theme.grey400Color};
    border-radius: 0.5rem;
    box-shadow: 0 0.25rem 0.75rem rgb(0 0 0 / 8%);
    max-height: 16rem;
    overflow-y: auto;

    li {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem 1rem;
      font-size: 0.875rem;
      color: ${({ theme }) => theme.grey900Color};
      cursor: pointer;

      &:hover {
        background: ${({ theme }) => theme.primary100Color};
      }
    }
  }
`

export const FilterLabel = styled.span`
  font-size: 0.6875rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.grey700Color};
`

export const FilterValue = styled.span`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.grey900Color};
  margin-top: 0.125rem;
  padding-right: 1.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FilterBarRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 0.75rem;

  &:last-child {
    margin-bottom: 0;
  }
`
